export default {

    state: () => ({
        easy_clean     : false,
        price          : 0,
        info           : '',
        name           : '',
        titleIfIncluded: ''
    }),

    action: {
        SET_PRICE            : (context, payload) => {
            context.commit('UPDATE_PRICE', payload);
        },
        SET_INFO             : (context, payload) => {
            context.commit('UPDATE_INFO', payload);
        },
        SET_NAME             : (context, payload) => {
            context.commit('UPDATE_NAME', payload);
        },
        SET_TITLE_IF_INCLUDED: (context, payload) => {
            context.commit('UPDATE_TITLE_IF_INCLUDED', payload);
        },
    },

    mutations: {
        UPDATE_PRICE            : (state, price) => {
            state.price = price;
        },
        UPDATE_INFO             : (state, info) => {
            state.info = info;
        },
        UPDATE_NAME             : (state, name) => {
            state.name = name;
        },
        UPDATE_TITLE_IF_INCLUDED: (state, title) => {
            state.titleIfIncluded = title;
        },
    },

    getters: {}

}